/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { css, jsx } from '@compiled/react';

import { token } from '@atlaskit/tokens';

const barStyles = css({
	position: 'absolute',
	width: token('space.050'),
	borderRadius: token('radius.full'),
	backgroundColor: token('color.border.information'),
	pointerEvents: 'none',
	marginLeft: token('space.negative.200'),
	positionVisibility: 'anchors-valid',
});

export function IndicatorBar({ localId }: { localId: string }): JSX.Element {
	return (
		<span
			data-testid="tool-call-highlight-bar"
			css={barStyles}
			style={{
				positionAnchor: `--local-id-anchor-${localId}-block`,
				left: `anchor(--local-id-anchor-${localId}-block left)`,
				top: `anchor(--local-id-anchor-${localId}-start top)`,
				bottom: `anchor(--local-id-anchor-${localId}-end bottom)`,
			}}
		/>
	);
}
